import { render, staticRenderFns } from "./UngulatesComponent.vue?vue&type=template&id=18dd46a9&"
import script from "./UngulatesComponent.vue?vue&type=script&lang=ts&"
export * from "./UngulatesComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports